import { Component, Inject } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import {
  DoctorV2Service,
  ListDoctorsResponse,
} from 'src/app/services/doctor-v2.service';

export type AvailableAdvancedFilters = {
  doctorId: number | null;
  doctorName: string | null;
};

@Component({
  selector: 'app-available-consolidated-schedules-filters-modal',
  templateUrl: './available-filters.modal.html',
})
export class AvailableConsolidatedSchedulesFiltersModalComponent {
  form: FormGroup;
  doctors: Array<{ id: number; name: string }> = [];

  constructor(
    private readonly fb: FormBuilder,
    private readonly dialogRef: MatDialogRef<AvailableConsolidatedSchedulesFiltersModalComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: { initial: AvailableAdvancedFilters | null },
    private readonly doctorService: DoctorV2Service
  ) {
    this.form = this.fb.group({
      doctorId: [data?.initial?.doctorId ?? null],
    });

    this.doctorService.findAll().subscribe((list: ListDoctorsResponse[]) => {
      this.doctors = (list || []).map((doctor) => ({
        id: doctor.id,
        name: doctor.name,
      }));
    });
  }

  close(): void {
    this.dialogRef.close('close');
  }

  apply(): void {
    const raw = this.form.getRawValue() as {
      doctorId: number | null;
    };

    const selectedDoctor = this.doctors.find(
      (doctor) => doctor.id === raw.doctorId
    );

    const payload: AvailableAdvancedFilters = {
      doctorId: raw.doctorId ?? null,
      doctorName: selectedDoctor ? selectedDoctor.name : null,
    };

    this.dialogRef.close(payload);
  }
}
